// 1 dòng thông báo (popover + trang). Text thuần: tin system là HTML do Admin soạn ⇒ bỏ thẻ, không render HTML.
import React from 'react'
import { Tag } from 'antd'
import { NotificationIcon, SUPPLIER_LABEL, timeAgo } from './notification-meta'
import styles from './notification-bell.module.scss'

const SUP_COLOR = { printbelle: 'purple', mangoteeprints: 'magenta', bondre: 'cyan', yunexpress: 'orange' }
export const plainText = (html) => String(html || '').replace(/<[^>]*>/g, ' ').replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ').trim()

export default function NotificationListItem({ item, onClick }) {
  return (
    <div className={`${styles.item} ${item.read_at ? '' : styles.unread}`} onClick={() => onClick(item)}>
      <span className={styles.icon}><NotificationIcon item={item} /></span>
      <div className={styles.body}>
        <div className={styles.title}>{item.title}</div>
        <div className={styles.desc}>
          {item.supplier && SUPPLIER_LABEL[item.supplier] && <Tag color={SUP_COLOR[item.supplier]} style={{ marginRight: 4 }}>{SUPPLIER_LABEL[item.supplier]}</Tag>}
          {plainText(item.body)}
        </div>
        <div className={styles.meta}>{item.id_site ? `${item.id_site} · ` : ''}{timeAgo(item.created_at)}</div>
      </div>
      {!item.read_at && <span className={styles.dot} />}
    </div>
  )
}
